// components
import NoData from "../../components/NoData";

const MarketplaceNoOffers = ({ isSearchActive }) => {
  return (
    <div className="marketplace__no-match">
      <NoData message={isSearchActive ? "NoOffersFound" : "NoOffers"} />
    </div>
  );
};

export default MarketplaceNoOffers;
